import { render, staticRenderFns } from "./InstructionalCoverageTable.vue?vue&type=template&id=15a263fa&scoped=true"
import script from "./InstructionalCoverageTable.vue?vue&type=script&lang=js"
export * from "./InstructionalCoverageTable.vue?vue&type=script&lang=js"
import style0 from "./InstructionalCoverageTable.vue?vue&type=style&index=0&id=15a263fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a263fa",
  null
  
)

export default component.exports